module.exports = __webpack_public_path__ + "static/img/tuiyanceshi.342f7f12.png";